
export class Base64Utils {

    public static blobToBase64(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (typeof reader.result === 'string') {
                    resolve(reader.result);
                } else {
                    reject(new Error("Erreur lors de la conversion du blob en base64."));
                }
            };
            reader.onerror = () => {
                reject(new Error("Erreur de lecture du blob."));
            };
            reader.readAsDataURL(blob);
        });
    }

    static base64ToBlob(base64: string, sliceSize = 512): Blob {
        let base64Data: string;
        let contentType: string;
        if (base64.indexOf('base64,')> -1) {
            base64Data = base64.split(',')[1];
            contentType =  base64.split(',')[0].replace('data:', '');
        } else {
            base64Data = base64;
            contentType = 'application/octet-stream'
        }
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    }
}